(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Shoppable-videos"] && !Shopify.designMode) return;
  try {
    
class KsShoppableVideos extends HTMLElement {
  constructor () {
    super()

    this.loadSwiper()
  }

  async loadSwiper() {
    // Load Swiper CSS
    if (!document.querySelector('#swiper-stylesheet')) {
      const stylesheet = document.createElement('link')
      stylesheet.setAttribute('href', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.css')
      stylesheet.setAttribute('rel', 'stylesheet')
      stylesheet.setAttribute('id', 'swiper-stylesheet')
      stylesheet.setAttribute('integrity', 'sha256-5nkrwjVsiNfKz3NR1k2h5+qt5pS5SF2u9/TIT1hElow=')
      stylesheet.setAttribute('crossorigin', 'anonymous')
      document.head.appendChild(stylesheet)
    }

    // Load Swiper JS and wait for it
    if (!window.Swiper) {
      await new Promise((resolve, reject) => {
        if (document.querySelector('#swiper-script')) {
          // Script tag exists, wait for Swiper to be available
          const checkSwiper = setInterval(() => {
            if (window.Swiper) {
              clearInterval(checkSwiper)
              resolve()
            }
          }, 50)
          return
        }

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.js')
        script.setAttribute('id', 'swiper-script')
        script.setAttribute('integrity', 'sha256-rCACDWCp/VzIh0rsB+ipQCM9XBvO8HNe0fNSOa4sys0=')
        script.setAttribute('crossorigin', 'anonymous')
        script.onload = resolve
        script.onerror = reject
        document.head.appendChild(script)
      })
    }

    // Initialize Swiper only after library is loaded
    this.initializeSwiper()
  }

  initializeSwiper() {
    const slider = new window.Swiper(this.querySelector('.swiper'), this.splideOptions())

    slider.on('slideChange', () => {
      this.querySelector('.swiper').classList.add('swiper-is-changing')
      this.onSlideChange()
    })

    slider.on('slideChangeTransitionEnd', () => {
      this.querySelector('.swiper').classList.remove('swiper-is-changing')
    })

    // Set up video controls
    this.setupVideoControls()
  }

  setupVideoControls() {
    this.querySelectorAll('.ks-shoppable-videos-btn-play').forEach(btn => {
      btn.addEventListener('click', () => {
        const video = btn.closest('.ks-shoppable-videos-video-wrapper').querySelector('video')
        this.onVideoPlay(video)
      })
    })

    this.querySelectorAll('video').forEach(video => {
      video.addEventListener('click', () => {
        this.onVideoPlay(video)
      })
      
      // Add event listeners to update button visibility
      video.addEventListener('play', () => {
        const card = video.closest('.ks-shoppable-videos-card')
        if (card) {
          card.setAttribute('data-is-playing', 'true')
        }
      })
      
      video.addEventListener('pause', () => {
        const card = video.closest('.ks-shoppable-videos-card')
        if (card) {
          card.setAttribute('data-is-playing', 'false')
        }
      })
    })

    // Autoplay all visible videos
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target
        if (entry.isIntersecting && video.dataset.autoplay === 'true') {
          video.play().catch(() => {})
        } else {
          video.pause()
        }
      })
    }, { threshold: 0.1 })
    
    this.querySelectorAll('video').forEach((video) => {
      observer.observe(video)
    })
  }

  splideOptions () {
    const partialSlidesMobile = this.dataset.partialSlidesMobile === 'true' ? 1.2 : 1

    /** @type {SwiperOptions} */
    const options = {
      rewind: true,
      speed: Number(this.dataset.sliderSpeed),
      breakpoints: {
        0: { slidesPerView: Number(this.dataset.breakpointXs) * partialSlidesMobile },
        576: { slidesPerView: Number(this.dataset.breakpointSm) },
        768: { slidesPerView: Number(this.dataset.breakpointMd) },
        992: { slidesPerView: Number(this.dataset.breakpointLg) },
        1200: { slidesPerView: Number(this.dataset.breakpointXl) },
        1400: { slidesPerView: Number(this.dataset.breakpointXxl) }
      },
      navigation: {
        enabled: this.dataset.sliderNav === 'true',
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev')
      },
      pagination: {
        enabled: this.dataset.sliderPagination === 'true',
        type: this.dataset.sliderPaginationType,
        el: '.swiper-pagination',
        dynamicBullets: true,
        dynamicMainBullets: 2,
        renderFraction: function (currentClass, totalClass) {
          return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`
        }
      },
      scrollbar: {
        enabled: this.dataset.sliderScrollbar === 'true',
        el: this.querySelector('.swiper-scrollbar'),
        draggable: true 
      },
      autoplay: this.dataset.sliderAutoplay !== '0'
        ? { delay: Number(this.dataset.sliderAutoplay) * 1000 }
        : undefined,
      watchSlidesProgress: true, 
      mousewheel: {
        enabled: true,
        forceToAxis: true
      },
    }
    return options
  }

  onSlideChange () {
    // Don't pause videos on slide change - let intersection observer handle it
  }

  onVideoPlay (video) {
    const card = video.closest('.ks-shoppable-videos-card')
    
    if (video.paused) {
      card.setAttribute('data-is-playing', 'true')
      video.muted = false
      video.play()
    } else {
      card.setAttribute('data-is-playing', 'false')
      video.pause()
    }
  }

}
customElements.define('ks-shoppable-videos', KsShoppableVideos)


  } catch(e) { console.error(e); }
})();
})();
